import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getExternaSystemInfo(id) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + id, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            });
    },
    deleteExternalSystem(id) {
        var msgType = "updateSuccess";
        return axios.delete(constants.BASE_URL + "/integrate/external-systems/" + id, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while deleting external systems"
                });
            }
        });
    },
    getExternalSystems(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/data?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external systems"
                    });
                }
            });
    },
    saveExternalSystem(dto) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems", dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getExternaSystemInfoWithConnType(id) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + id + "/api-points/external-system-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            });
    }, saveExternalSystemAPI(externalSystemId, dto) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/api-points", dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    }, getExternalSystemAPI(externalSystemId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/api-points/" + apiId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": error.message
            });
        });
    },
    deleteExternalSystemAPI(externalSystemId, apiId) {
        var msgType = "updateSuccess";
        return axios.delete(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/api-points/" + apiId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while deleting external systems API"
                });
            }
        });
    },
    getRestAdapters(externalSystemId, apiId, input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/restadapters?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching adapters"
                });
            }
        });

    },
    getSQLAdapters(externalSystemId, apiId, input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/externalsystems/" + externalSystemId + "/apis/" + apiId + "/sqladaptersAPI/sqldata?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching adapters"
                });
            }
        });

    },
    getFileAdapters(externalSystemId, apiId, input) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/fileadapters/filedata?" + input, {
            withCredentials: true
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching adapters"
                });
            }
        });

    },
    getFileFileAdapterInfo(url) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            });
    },
    getConnectionInfo(url) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        })
        .then(response => {
            return response.data;
        })
        .catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while fetching connection"
                });
            }
        });
    },
    saveFileAdpater(dto, externalSystemId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/fileadapters", dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    deleteFileAdapter(externalSystemId, apiId, adapterId) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/integrate/external-systems/" + externalSystemId + "/apis/" + apiId + "/fileadapters/" + adapterId).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Error while deleting file adapter"
            });
        });
    }, saveFileConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/fileconnections/" + connectionId, dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    }, deleteFileConnection(connectionId, apiId, endPoint) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/fileconnections/" + connectionId + endPoint).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Error while deleting file adapter"
            });
        });
    }, testFileConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/fileconnections/" + connectionId + "/test-connection", dto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Error while testing file connection"
            });
        });
    },
    saveRestConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/restconnections/" + connectionId, dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    testRestConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/restconnections/" + connectionId + "/test-connection", dto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": "Error while testing rest connection"
            });
        });
    },
    saveDatabaseConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/database-connections/" + connectionId, dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    testDatabaseConnection(dto, connectionId, apiId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/integrate/external-systems/" + apiId + "/database-connections/" + connectionId + "/test", dto).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getExternalSystemsAPI(id, input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + id + "/api-points/api-list?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external system APIs"
                    });
                }
            });
    },
    getExternalSystemsConnections(id, input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/" + id + "/database-connections?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external system connections"
                    });
                }
            });
    }
}
